import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import Footer from "../components/Footer";
import main_logo from '../assets/images/UPG_site_logo.png';

import { Profile, GetPages, FilterDynamicText, getSetting } from '../API/admin'
import { PhotoAPI } from '../API/player';
import Loader from '../views/admin/Common/Loader'
import Swal from "sweetalert2";
import { useSnackbar } from 'notistack'


function TermsandCondition() {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [dynamicHeading, setDynamicHeading] = useState({});
    const [loginUser, setLoginUser] = useState(null)
    const [PageContent, setPageContent] = useState(null)
    let [loaderStatus, setloaderStatus] = useState(true)
    const [TournamentOff, setTouramentOff] = useState(false);

    const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;
    useEffect(() => {
        let callAPI = async () => {
            let res = await getSetting()

            if (res.status) {
                res.data.map((entry, index) => {
                    if (entry.value == 'false' && entry.name === 'tournament_register') {
                        setTouramentOff(true);
                    }
                })
            } else {
                // setIsOn(null);
                enqueueSnackbar('unable to fetch setting', {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                })
            }
        }
        callAPI()
    }, [])
    useEffect(() => {
        let callAPI = async () => {
            setloaderStatus(true);
            let res = await GetPages('terms_and_condition');
            console.log(res);
            if (res.status) {
                setloaderStatus(false);

                setPageContent(res.data.page_body)
            } else {
                setloaderStatus(false);

            }
        }
        let callAPIProfile = async () => {
            let res = await Profile()
            console.log(res)
            if (res.statusCode == 403) {
                setLoginUser(null)
                setloaderStatus(false)
            } else {
                setLoginUser(res.data)
                setloaderStatus(false)
            }
        }
        callAPIProfile()
        callAPI()
    }, [])

    //  Photo/Video Request hit 
    useEffect(() => {

        let callAPIDynamictext = async () => {
            let formData = {
                "data": null
            }
            let res = await FilterDynamicText(formData);
            if (res.data.status) {
                console.log(res.data.data)
                setDynamicHeading(res.data.data)
            }
        }
        callAPIDynamictext();
    }, [])

    let PhotoReq = async () => {
        console.log("Hello")
        Swal.fire({
            title: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.title
                : "Request photo/video?",
            text: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.value : "Request photo/video?",
            // icon: "warning",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send Request",
            showCancelButton: true,
            cancelButtonText:"close"
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await PhotoAPI();
                if (res.data.status) {
                    if (res.data.NoMatch) {
                        enqueueSnackbar('You have not played any matches yet', {
                            variant: 'error', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    } else {

                        enqueueSnackbar('Request was sent successfully', {
                            variant: 'success', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    }
                } else {
                    enqueueSnackbar('Unable to send request at the moment', {
                        variant: 'error', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    })
                }

            }
        });

    }

    //    My profile navigation
    let Myprofilenavigate;
    if (loginUser) {
        switch (loginUser.role) {
            case "participant":
                Myprofilenavigate = "/participant/profile";
                break;
            case "admin":
                Myprofilenavigate = "/admin/profile";
                break;
            case "scorer":
                Myprofilenavigate = "/scorer/profile";
                break;
            default:
                Myprofilenavigate = "/";
                break;
        }
    } else {
        Myprofilenavigate = "/"; // Redirect to login if user is not logged in
    }


    return (
        <>
            {loaderStatus ? <Loader /> : null}

            <div className="main_div_heigtport">
                <header>
                    <nav className='navbar navbar-expand-lg navbar-light pt-3 pb-2 px-5 head_nav_landingpage'>
                        <a className='navbar-brand' href='/'>
                            <img src={main_logo} alt='Logo' />
                        </a>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            style={{ background: '#B2022F' }}
                        >
                            {/* <span className="navbar-toggler-icon" /> */}
                            <i class="bi bi-list" style={{ color: "#fff", fontSize: "25px" }}></i>
                        </button>
                        <div className='collapse navbar-collapse' id='navbarNav'>
                            <ul className='navbar-nav ms-auto'>
                                {loginUser != null ? (
                                    <>
                                        <li className='nav-item'
                                            style={{ display: (loginUser != null) ? "block" : "none" }} >
                                            <NavLink className='nav_page_btn mobile_displa_dashboard'
                                                to='/dashboard' activeClassName='active'>
                                                Dashboard
                                            </NavLink>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/'>
                                                Home
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/Results'>
                                                Results
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/photo-gallery'>
                                                Gallery
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/contact'>
                                                Get in Touch
                                            </a>
                                        </li>
                                        <li className='nav-item dropdown'>
                                            <a
                                                className='nav-link dropdown-toggle'
                                                href='#'
                                                id='navbarDropdown'
                                                role='button'
                                                data-bs-toggle='dropdown'
                                                aria-expanded='false'
                                            >
                                                <img
                                                    src={
                                                        loginUser.profile_image !== undefined
                                                            ? IMAGE_URL + 'user/' + loginUser.profile_image
                                                            : IMAGE_URL + 'blank_user.png'
                                                    }
                                                    alt='Profile'
                                                    className='rounded-circle'
                                                    style={{
                                                        width: "60px",
                                                        height: "60px",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            </a>
                                            <ul className="dropdown-menu dropdown-menu-end new_header_dropdown" aria-labelledby="navbarDropdown">
                                                <li className='mobile_displa_popup_dashboard'>
                                                    <Link className="dropdown-item" to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li>
                                                    <NavLink className="dropdown-item" to={Myprofilenavigate}>My Profile</NavLink>
                                                </li>
                                                <li style={{ display: (loginUser.role === "participant") ? "block" : "none" }}
                                                    onClick={() => PhotoReq()}>
                                                    <Link className="dropdown-item"> Request Photo/Video</Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/logout">Logout</Link>
                                                </li>
                                            </ul>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                    <li className='nav-item'>
                                            <a className='nav_page_btn' href='/'>
                                                Home
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/Results'>
                                                Results
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/photo-gallery'>
                                                Gallery
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/contact'>
                                                Get in Touch
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            {/* Changed to NavLink */}
                                            <a className='login_btn' href='/login'>
                                                Register Now
                                            </a>

                                            </li>
                                          
                                        <li className='nav-item'>
                                            <a className='login_btn' href='/login'>
                                                Login
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </nav>
                </header>
                <section className='headre_bg_div'></section>
                <div className='container-fluid pt-4 pb-5 flex-grow-1' style={{ background: "#000" }}>
                    <div className='container-lg text-white'>
                        <h3 className='all_new_pages_heading'>
                            TERMS & CONDITIONS
                        </h3>

                        {
                            PageContent != null ? (
                                <div className='text-white' >
                                    <div dangerouslySetInnerHTML={{ __html: PageContent }} />
                                </div>
                            ) :
                                <>
                                    <div className='d-flex align-items center'>
                                        <div className='nodata_row bg-dark'>
                                            No terms & conditions found
                                        </div>
                                    </div>
                                </>
                        }
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default TermsandCondition;
